import React, { memo, useState } from 'react'
import InboxItem from './InboxItem';
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@app/lib/store';
import { useQuery } from '@tanstack/react-query';
import { getContacts } from './API';
import { Trans } from '@ui/i18n/trans';

interface InpoxProbs{
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function Inbox({setModalOpen}:InpoxProbs) {

  const { currentReciever } = useSelector((state: RootState) => state.chat);
  const {data} = useQuery({
    queryKey: ['getContacts'],
    queryFn: ()=>getContacts(),
    refetchInterval: 200,
  })

  const contacts = data?.data?.contacts
  // console.log(contacts);
  
  // getContacts().then(data=>console.log(data));

//   const timeAgo = (date) => {
//     const now = new Date();
//     const seconds = Math.floor((now - date) / 1000);
//     const minutes = Math.floor(seconds / 60);
//     const hours = Math.floor(minutes / 60);
//     const days = Math.floor(hours / 24);
//     const months = Math.floor(days / 30);  // approx 30 days per month
//     const years = Math.floor(days / 365);  // approx 365 days per year

//     if (seconds < 60) {
//         return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
//     } else if (minutes < 60) {
//         return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
//     } else if (hours < 24) {
//         return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
//     } else if (days < 30) {
//         return `${days} day${days !== 1 ? 's' : ''} ago`;
//     } else if (months < 12) {
//         return `${months} month${months !== 1 ? 's' : ''} ago`;
//     } else {
//         return `${years} year${years !== 1 ? 's' : ''} ago`;
//     }
// }
  

  return (
    <div className='h-full min-w-[312px] overflow-y-auto max-w-[336px] w-full rounded-[16px] p-16 bg-white dark:bg'>
      <InboxHeader setModalOpen={setModalOpen}></InboxHeader>
      <div className='mt-24 flex flex-col gap-16'>
        {contacts?.map((contact: User)=>{
        return (<InboxItem 
          key={contact.email}
          avatar={contact?.image || contact?.avatar || ''}
          name={contact.name || contact.username || (contact.first_name ? `${contact.first_name} ${contact.last_name}` : '')}
          // time={timeAgo(new Date(contact?.updated_at))}
          // displayedMessage={contact?.last_message}
          id={contact?.id}
          user={contact}
          ></InboxItem>);
        })}
        
      </div>
    </div>
  )
}

export default memo(Inbox);


function InboxHeader({setModalOpen}:InpoxProbs){
    return (
        <div className='w-full flex items-center justify-between'>
            <h3 className='text-darkBlue text-[18px] font-[500] leading-[27px] dark:text-white'><Trans message='Inbox'/></h3>
            <button className='bg-primary text-white rounded-[10px]'  onClick={(e)=>{setModalOpen(true); e.preventDefault(); e.stopPropagation();}}>
              <div className='py-10 px-16 flex items-center gap-8'>
                <PlusIcon></PlusIcon>
                <span className='text-[14px] leading-[21px] font-[500]'><Trans message='Add chat'/></span>
              </div>
            </button>
        </div>
    );
}

function PlusIcon(){
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4.5V19.5M19.5 12H4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
    );
}